import React, { useMemo, useState } from "react";

import { FieldGroup, Table } from "../../../components";

import { ConfirmButtons } from "./ConfirmButtons";
import ProductRow from "./ProductRow";
import BuyAlertPrompt from "../../../requests/components/molecules/BuyAlertPrompt.jsx";

const DesktopView = ({
  handleSubmit,
  clientName,
  product,
  isUnknwon,
  isEditing,
  isOrder,
  requestType,
  setChoice,
  buttons,
  paidOffline,
  requestImages,
  currency,
}) => {
  const [images, setImages] = useState(requestImages);
  const headers = ["Product", "Model", "Ref.", "Select details"];

  if (clientName) {
    headers.unshift("Name");
  }

  const rows = useMemo(() => {
    if (isUnknwon) {
      return [{ id: "unkown", clientName, isUnknwon }];
    }

    return product ? [{ id: "prod", clientName, product }] : [];
  }, [isUnknwon, product, clientName]);

  return (
    <div
      className={`confirm-request-desktop ${
        isOrder ? "source-req" : "sell-req"
      }`}
    >
      <Table
        {...{
          headers,
          rows,
          responsive: false,
          RowComponent: ProductRow,
          componentProps: {
            isOrder,
            paidOffline,
            isEditing,
            requestType,
          },
        }}
      />

      <div className="row mt-3">
        <div className="col-12 ml-2">
          <h4>Real Images</h4>
        </div>
        <div className="col-12">
          <FieldGroup
            className={"mt-0"}
            placeholder=""
            name="images"
            type="galleryUpload"
            value={images}
            onChange={(images) => setImages(images)}
          />
        </div>
      </div>

      {/* Orders only: a sell request is us buying, so there is no supplier to
          watch for. Rendered above the buttons so it is read before the deal
          is finished rather than after. */}
      {isOrder && <BuyAlertPrompt currency={currency} />}

      <ConfirmButtons {...{ handleSubmit, setChoice, buttons }} />
    </div>
  );
};

export default DesktopView;
